import { Injectable, signal } from '@angular/core';
import {
    HttpBackend,
    HttpClient,
    HttpErrorResponse,
    HttpEvent,
    HttpEventType,
    HttpHeaders,
    HttpParams,
} from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class DealsService {

    serverUrl = environment.serverUrl;
    httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };

    //private http: HttpClient;
    private static cacheBuster$: Subject<void> = new Subject<void>();
    constructor(handler: HttpBackend, private http: HttpClient) {
        //this.http = new HttpClient(handler);
    }

    get_live_deal_by_exec_in_charge(exec_in_charge: string) {
        return this.http.get<[]>(this.serverUrl + 'local/get_live_deal_by_exec_in_charge/' + exec_in_charge, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    get_live_deals_by_bu_and_deal_nature_and_exec(bu: string, deal_nature: string, exec_in_charge: string = '') {
        const payload = {
            bu: bu || '',
            deal_nature: deal_nature || '',
            exec_in_charge: exec_in_charge || ''
        };
        return this.http.post<[]>(this.serverUrl + 'local/get_live_deals_by_bu_and_deal_nature_and_exec', payload, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    set_manual_ao(slug_deal, aoFile: File | null = null) {
        const formData = new FormData();
        if (aoFile) {
            formData.append('file_ao', aoFile);
        }
        return this.http.post<any>(this.serverUrl + 'local/set_manual_ao/' + slug_deal, formData)
            .pipe(
                catchError(this.handleError)
            );
    }

    /** The AO document is streamed from the internal GED (or from disk for legacy rows). */
    download_manual_ao_file(intervention_proposal_id: number) {
        return this.http.get(this.serverUrl + 'local/download_manual_ao_file/' + intervention_proposal_id, { responseType: 'blob' })
            .pipe(
                catchError(this.handleError)
            );
    }

    update_crm_opportunity_instrument_tranche(identifiant: any, request: any) {
        return this.http.post<any>(this.serverUrl + 'valo/update_crm_opportunity_instrument_tranche/' + identifiant, request, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    deleteItem(id: number, type: 'role_afs' | 'product_fees' = 'role_afs'): Observable<any> {
        if (type === 'role_afs') {
            return this.http.post<any>(this.serverUrl + 'local/delete_role_afs_by_id/' + id, this.httpOptions)
                .pipe(
                    catchError(this.handleError)
                );
        } else if (type === 'product_fees') {
            return this.http.post<any>(this.serverUrl + 'local/delete_product_fees/' + id, this.httpOptions)
                .pipe(
                    catchError(this.handleError)
                );
        }
        return throwError(() => new Error('Type non supporté'));
    }

    delete_crm_opportunity_instrument_tranche(identifiant: any, tranche_id: any) {
        return this.http.post<any>(this.serverUrl + 'valo/delete_crm_opportunity_instrument_tranche/' + identifiant + '/' + tranche_id, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    get_type_instrument() {
        return this.http.get<any>(this.serverUrl + 'valo/get_type_instrument', this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    delete_crm_opportunity_instrument(identifiant: any, instrument_id: any) {
        return this.http.post<any>(this.serverUrl + 'valo/delete_crm_opportunity_instrument/' + identifiant + '/' + instrument_id, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    get_crm_opportunity_portfolio(identifiant: any) {
        return this.http.get<any>(this.serverUrl + 'valo/get_crm_opportunity_portfolio/' + identifiant, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    update_crm_opportunity_instrument(identifiant: any, request: any) {
        return this.http.post<any>(this.serverUrl + 'valo/update_crm_opportunity_instrument/' + identifiant, request, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    update_crm_opportunity_portfolio(identifiant: any, request: any) {
        return this.http.post<any>(this.serverUrl + 'valo/update_crm_opportunity_portfolio/' + identifiant, request, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    get_associate_role() {
        return this.http.get<any>(this.serverUrl + 'company/get_associate_role', this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    // No handleError: the dialog shows the server sentence (who may change the seat, why it failed).
    set_exec_in_charge(slug_deal, data) {
        return this.http.post<any>(this.serverUrl + 'local/set_exec_in_charge/' + slug_deal, data, this.httpOptions);
    }

    // No handleError: the dialog shows the server sentence (who may change the seat, why it failed).
    set_supervisor(slug_deal, data) {
        return this.http.post<any>(this.serverUrl + 'local/set_supervisor/' + slug_deal, data, this.httpOptions);
    }

    // No handleError: the dialog shows the server sentence (who may change the seat, why it failed).
    set_busdev_in_charge(slug_deal, data) {
        return this.http.post<any>(this.serverUrl + 'local/set_busdev_in_charge/' + slug_deal, data, this.httpOptions);
    }

    remove_cde_file(slug_deal, file_id) {
        return this.http.post<any>(this.serverUrl + 'cde_controller/remove_cde_file/' + slug_deal + '/' + file_id, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    generate_proposal_pdf(slug_deal, id = null) {
        return this.http.get<any>(this.serverUrl + 'crm_document/generate_proposal_pdf/' + slug_deal + (id ? '/' + id : ''), this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    reject_ao(slug_deal, id = null) {
        return this.http.get<any>(this.serverUrl + 'crm_document/reject_ao/' + slug_deal + (id ? '/' + id : ''), this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    accept_ao(slug_deal, id = null, slug_user = null) {
        const body = {
            slug_deal: slug_deal,
            intervention_proposal_id: id,
            slug_user: slug_user
        };
        return this.http.post<any>(this.serverUrl + 'crm_document/accept_ao', body, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    generate_proposal_pptx(slug_deal) {
        return this.http.get<any>(this.serverUrl + 'crm/generate_proposal_pptx/' + slug_deal, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    ignore_cde(slug_deal: string) {
        return this.http.post<any>(this.serverUrl + 'cde_controller/ignore_cde/' + slug_deal, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    add_group(request: any) {
        return this.http.post<any>(this.serverUrl + 'local/add_group', request, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    update_group(request: any) {
        return this.http.post<any>(this.serverUrl + 'local/update_group/' + request.id, request, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    update_sharepoint_opportunity(opportunity: any) {
        return this.http.post<any>(this.serverUrl + 'local/update_sharepoint_opportunity', opportunity, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    update_user_role(request: any) {
        return this.http.post<any>(this.serverUrl + 'local/update_user_role', request, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    get_groups() {
        return this.http.get<any>(this.serverUrl + 'local/get_groups', this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    get_roles_afs() {
        return this.http.get<any>(this.serverUrl + 'local/get_afs_roles', this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    set_ao_form(slug_deal, data) {
        return this.http.post<any>(this.serverUrl + 'local/set_ao_form/' + slug_deal, data, {
            reportProgress: true,
            observe: 'events'
        })
            .pipe(
                map(event => this.getEventMessage(event)),
                catchError(this.handleError)
            );
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    get_cde_list() {
        return this.http.get<any>(this.serverUrl + 'crm_billing/get_cde_list', this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    get_cde_list_history() {
        return this.http.get<any>(this.serverUrl + 'crm_billing/get_cde_list_history', this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    get_cde_form(slug_deal) {
        return this.http.get<any>(this.serverUrl + 'cde_controller/get_cde_form/' + slug_deal, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    get_cde_users_manager() {
        return this.http.get<any>(this.serverUrl + 'cde_controller/get_cde_users_manager', this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    set_cde_form(slug_deal, data) {
        return this.http.post<any>(this.serverUrl + 'cde_controller/set_cde_form/' + slug_deal, data, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    get_cde_report(slug_deal) {
        return this.http.get<any>(this.serverUrl + 'cde_controller/get_cde_report/' + slug_deal, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    set_cde_step2(slug_deal, data) {
        return this.http.post<any>(`${this.serverUrl}cde_controller/set_cde_step2/${slug_deal}`, data, {
            reportProgress: true,
            observe: 'events'
        })
            .pipe(
                map(event => this.getEventMessage(event)),
                catchError(this.handleError)
            );
    }

    set_cde_step3(slug_deal, data) {
        return this.http.post<any>(this.serverUrl + 'cde_controller/set_cde_step3/' + slug_deal, data, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    set_cde_admin(slug_deal, data) {
        return this.http.post<any>(this.serverUrl + 'cde_controller/set_cde_admin/' + slug_deal, data, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    get_cde_history(slug_deal) {
        return this.http.get<any>(this.serverUrl + 'cde_controller/get_cde_history/' + slug_deal, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    updateHpClause(request: any) {
        return this.http.post<any>(this.serverUrl + 'local/updateHpClause/' + request.slug, request, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    add_timesheet(slug_deal, request: any) {
        return this.http.post<any>(this.serverUrl + 'local/add_timesheet/' + slug_deal, request, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    update_timesheet(slug_deal, request: any) {
        return this.http.post<any>(this.serverUrl + 'timesheet/update_timesheet/' + slug_deal, request, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    get_timesheet(slug_deal) {
        return this.http.get<any>(this.serverUrl + 'local/get_timesheet/' + slug_deal, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    get_distribution_list_contact(request) {
        return this.http.post<any>(this.serverUrl + 'local/get_distribution_list_contact', request, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    confirm_period_timesheet(slug_deal, request) {
        return this.http.post<any>(this.serverUrl + 'local/confirm_period_timesheet/' + slug_deal, request, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    delete_timesheet(slug_deal, request: any) {
        return this.http.post<any>(this.serverUrl + 'local/delete_timesheet/' + slug_deal, request, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    searchOpportunities(any: any) {
        return this.http.post<any>(this.serverUrl + 'local/search_opportunities', any, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    searchDeals(any: any) {
        return this.http.post<any>(this.serverUrl + 'local/searchDeals', any, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }


    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    searchLenders(any: any) {
        return this.http.post<any>(this.serverUrl + 'local/searchLenders', any, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    searchAppointments(any: any) {
        return this.http.post<any>(this.serverUrl + 'local/searchAppointments', any, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    add_csr_mechanics(any: any) {
        return this.http.post<any>(this.serverUrl + 'local/add_csr_mechanics', any, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //fonction get_csr_mechanics
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_csr_mechanics(slug) {
        return this.http.get<[]>(this.serverUrl + 'local/get_csr_mechanics/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }


    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getUserDeals(slug) {
        return this.http.get<[]>(this.serverUrl + 'local/getUserDeals/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_live_deal_by_bu(slug) {
        return this.http.get<[]>(this.serverUrl + 'local/get_live_deal_by_bu/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //fonction update_csr_mechanics
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    update_csr_mechanics(id, any: any) {
        return this.http.post<any>(this.serverUrl + 'local/update_csr_mechanics/' + id, any, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //fonction delete_csr_mechanics
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    delete_csr_mechanics(id) {
        return this.http.post<any>(this.serverUrl + 'local/delete_csr_mechanics/' + id, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //fonction add_toggle_option_detail
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    add_toggle_option_detail(any: any) {
        return this.http.post<any>(this.serverUrl + 'local/add_toggle_option_detail', any, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //fonction edit_toggle_option_detail
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    edit_toggle_option_detail(id, any: any) {
        return this.http.post<any>(this.serverUrl + 'local/edit_toggle_option_detail/' + id, any, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    updateDealScoring(request: any) {
        return this.http.post<any>(this.serverUrl + 'local/updateDealScoring/' + request.slug, request, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    updateDealSponsor(request: any) {
        return this.http.post<any>(this.serverUrl + 'local/updateDealSponsor/' + request.slug, request, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    updateCompanyInvestor(request: any) {
        return this.http.post<any>(this.serverUrl + 'local/updateCompanyInvestor/' + request.slug, request, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    updateCompanyContact(request: any) {
        return this.http.post<any>(this.serverUrl + 'local/updateCompanyContact/' + request.slug, request, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    updateBusProvider(request: any) {
        return this.http.post<any>(this.serverUrl + 'local/updateBusProvider/' + request.slug, request, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //fonction get_toggle_option_detail
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_toggle_option_detail(slug) {
        return this.http.get<[]>(this.serverUrl + 'local/get_toggle_option_detail/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    edit_earliest_closing_date(id, maturity_date) {
        return this.http.post<any>(this.serverUrl + 'local/edit_earliest_closing_date/' + id + '/' + maturity_date, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //fonction get_csr_data
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_csr_data(slug) {
        return this.http.get<[]>(this.serverUrl + 'local/get_csr_data/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    add_csr_data(any: any) {
        return this.http.post<any>(this.serverUrl + 'local/add_csr_data', any, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }


    /* Get all corporate by deal */
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_all_corporate_with_deal() {
        return this.http.get<[]>(this.serverUrl + 'local/get_all_corporate_with_deal')
            .pipe(
                catchError(this.handleError)
            );
    }

    /* Get all corporate by deal */
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_all_corporate_with_deal_assigned(sluguser) {
        return this.http.get<[]>(this.serverUrl + 'local/get_all_corporate_with_deal_assigned/' + sluguser, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    generate_invoices(slug_deal) {
        return this.http.get<[]>(this.serverUrl + 'crm_billing/generate_invoices/' + slug_deal, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    /* Get all corporate by deal */
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_tranche_coupons_detail_margin_history(slugtranche, type) {
        return this.http.get<[]>(this.serverUrl + 'local/get_tranche_coupons_detail_margin_history/' + slugtranche + '/' + type, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    check_margin_value_by_deal_covenant_cash(tranche, slugtranche) {
        return this.http.get<[]>(this.serverUrl + 'local/check_margin_value_by_deal_covenant_cash/' + tranche + '/' + slugtranche, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    check_margin_value_by_deal_covenant_pik(tranche, slugtranche) {
        return this.http.get<[]>(this.serverUrl + 'local/check_margin_value_by_deal_covenant_pik/' + tranche + '/' + slugtranche, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    /* Get all corporate by deal */
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_all_corporate_with_deal_assigned_count(sluguser) {
        return this.http.get<[]>(this.serverUrl + 'local/get_all_corporate_with_deal_assigned_count/' + sluguser, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_wgl_issuer_by_deal_tranche(deal, tranche) {
        return this.http.get<[]>(this.serverUrl + 'local/get_wgl_issuer_by_deal_tranche/' + deal + '/' + tranche, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_wgl_investor_by_deal_tranche(deal, tranche) {
        return this.http.get<[]>(this.serverUrl + 'local/get_wgl_investor_by_deal_tranche/' + deal + '/' + tranche, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_wgl_investor_lawyer_by_deal_tranche(deal, tranche) {
        return this.http.get<[]>(this.serverUrl + 'local/get_wgl_investor_lawyer_by_deal_tranche/' + deal + '/' + tranche, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_wgl_thirdparty_by_deal_tranche(deal, tranche) {
        return this.http.get<[]>(this.serverUrl + 'local/get_wgl_thirdparty_by_deal_tranche/' + deal + '/' + tranche, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_wgl_issuer_by_deal(deal) {
        return this.http.get<[]>(this.serverUrl + 'local/get_wgl_issuer_by_deal/' + deal, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_wgl_investor_by_deal(deal) {
        return this.http.get<[]>(this.serverUrl + 'local/get_wgl_investor_by_deal/' + deal, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_wgl_investor_lawyer_by_deal(deal) {
        return this.http.get<[]>(this.serverUrl + 'local/get_wgl_investor_lawyer_by_deal/' + deal, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_wgl_thirdparty_by_deal(deal) {
        return this.http.get<[]>(this.serverUrl + 'local/get_wgl_thirdparty_by_deal/' + deal, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }




    /* Add corporate */
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_bu_by_slug(slug) {
        return this.http.get<[]>(this.serverUrl + 'local/get_bu_by_slug/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    /* Add corporate */
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_deal_nature_by_slug(slug) {
        return this.http.get<[]>(this.serverUrl + 'local/get_deal_nature_by_slug/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    get_deal_nature_by_slug_bu(slug) {
        return this.http.get<[]>(this.serverUrl + 'local/get_deal_nature_by_slug_bu/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    /* Add corporate */
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_corporate_by_slug(slug) {
        return this.http.get<[]>(this.serverUrl + 'company/get_corporate_by_slug/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_listrolebybu(slug) {
        return this.http.get<[]>(this.serverUrl + 'local/get_listrolebybu/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_convenant_financial_data(slug) {
        return this.http.get<[]>(this.serverUrl + 'local/get_convenant_financial_data/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    add_corporate(corporatepost: any) {
        return this.http.post<any>(this.serverUrl + 'company/add_corporate', corporatepost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    addCouponsDateCalendar(id, couponsdatepost: any) {
        return this.http.post<any>(this.serverUrl + 'local/addCouponsDateCalendar/' + id, couponsdatepost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    addFinancialMonitoringDateCalendar(id, couponsdatepost: any) {
        return this.http.post<any>(this.serverUrl + 'local/addFinancialMonitoringDateCalendar/' + id, couponsdatepost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    EditFinancialMonitoringCalendar(couponsdatepost: any, id) {
        return this.http.post<any>(this.serverUrl + 'local/EditFinancialMonitoringCalendar/' + id, couponsdatepost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    addValoReportingDateCalendar(id, couponsdatepost: any) {
        return this.http.post<any>(this.serverUrl + 'local/addValoReportingDateCalendar/' + id, couponsdatepost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    update_closing_data(any: any, slug) {
        return this.http.post<any>(this.serverUrl + 'local/update_closing_data/' + slug, any, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    add_covenant_data(covenantspost: any) {
        return this.http.post<any>(this.serverUrl + 'local/add_covenant_data', covenantspost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: CrmService.cacheBuster$ })
    edit_corporate_covenant_data(corporateconvenantdatapost: any) {
        return this.http.post<any>(this.serverUrl + 'local/edit_covenant_data/' + corporateconvenantdatapost.id, corporateconvenantdatapost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    delete_covenant_data(slug) {
        return this.http.post<any>(this.serverUrl + 'local/delete_covenant_data/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    delete_corporate(slug) {
        return this.http.post<any>(this.serverUrl + 'company/delete_corporate/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    delete_folder_client(slug, id) {
        return this.http.post<any>(this.serverUrl + 'local/delete_folder_client/' + slug + '/' + id, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    delete_file_client(slug, id, filename, parent_id) {
        return this.http.post<any>(this.serverUrl + 'local/delete_file_client/' + slug + '/' + id + '/' + filename + '/' + parent_id, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    delete_date_coupons(id) {
        return this.http.post<any>(this.serverUrl + 'local/delete_date_coupons/' + id, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    delete_date_financial_monitoring(id) {
        return this.http.post<any>(this.serverUrl + 'local/delete_date_financial_monitoring/' + id, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    delete_date_reporting(id) {
        return this.http.post<any>(this.serverUrl + 'local/delete_date_reporting/' + id, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    delete_access_client(id) {
        return this.http.post<any>(this.serverUrl + 'local/delete_access_client/' + id, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    /*--------------------------*/




    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    update_corporate_logo(formData) {
        return this.http.post<any>(this.serverUrl + 'company/update_corporate_logo', formData, {
            reportProgress: true,
            observe: 'events'
        })
            .pipe(
                map(event => this.getEventMessage(event)),
                catchError(this.handleError)
            );
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    delete_img_corporate_logo(formData) {
        return this.http.post<any>(this.serverUrl + 'company/delete_img_corporate_logo', formData, {
            reportProgress: true,
            observe: 'events'
        })
            .pipe(
                map(event => this.getEventMessage(event)),
                catchError(this.handleError)
            );
    }


    /* Add deal */
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_deal() {
        return this.http.get<[]>(this.serverUrl + 'local/get_deal')
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_live_deal() {
        return this.http.get<[]>(this.serverUrl + 'local/get_live_deal')
            .pipe(
                catchError(this.handleError)
            );
    }

    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_nb_live_deal() {
        return this.http.get<[]>(this.serverUrl + 'local/get_nb_live_deal')
            .pipe(
                catchError(this.handleError)
            );
    }


    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_live_deal_paginated(request: any) {
        return this.http.post<[]>(this.serverUrl + 'local/get_live_deal_paginated', request, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_deal_infos(slug) {
        return this.http.get<[]>(this.serverUrl + 'local/get_deal_infos/' + slug)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_deal_closed() {
        return this.http.get<[]>(this.serverUrl + 'local/get_deal_closed')
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_prending_deal() {
        return this.http.get<[]>(this.serverUrl + 'local/get_prending_deal')
            .pipe(
                catchError(this.handleError)
            );
    }

    get_users_with_role() {
        return this.http.get<[]>(this.serverUrl + 'local/get_users_with_role')
            .pipe(
                catchError(this.handleError)
            );
    }

    get_users_actions(
        date_debut?: string,
        date_fin?: string,
        page?: number,
        page_size?: number,
        q?: string,
        entity_ids?: number[],
        verb_ids?: number[],
        user_ids?: number[],
        module_ids?: number[],
    ) {
        let params = new HttpParams();
        if (date_debut) {
            params = params.set('date_debut', date_debut);
        }
        if (date_fin) {
            params = params.set('date_fin', date_fin);
        }

        // API User_action::get_users_actions attend limit + offset (pas page / page_size)
        if (page != null && page_size != null && page > 0 && page_size > 0) {
            const offset = (page - 1) * page_size;
            params = params.set('limit', String(page_size));
            params = params.set('offset', String(offset));
        }

        if (q && q.trim()) {
            params = params.set('search', q.trim());
        }

        if (entity_ids && entity_ids.length) {
            params = params.set('entity_ids', entity_ids.join(','));
        }
        if (verb_ids && verb_ids.length) {
            params = params.set('verb_ids', verb_ids.join(','));
        }
        if (user_ids && user_ids.length) {
            params = params.set('user_ids', user_ids.join(','));
        }
        if (module_ids && module_ids.length) {
            params = params.set('module_ids', module_ids.join(','));
        }

        return this.http.get<any>(this.serverUrl + 'user_action/get_users_actions', { params })
            .pipe(
                catchError(this.handleError)
            );
    }

    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_iban_jm() {
        return this.http.get<[]>(this.serverUrl + 'local/get_iban_jm')
            .pipe(
                catchError(this.handleError)
            );
    }

    createIbanJm(request: any) {
        return this.http.post<any>(this.serverUrl + 'local/createIbanJm', request, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getIbanJmNoticeImports(dealId?: number | null, slugDeal?: string | null) {
        let query = '';
        const params: string[] = [];
        if (dealId) {
            params.push(`deal_id=${encodeURIComponent(String(dealId))}`);
        }
        if (slugDeal) {
            params.push(`slug_deal=${encodeURIComponent(slugDeal)}`);
        }
        if (params.length) {
            query = `?${params.join('&')}`;
        }
        return this.http
            .get<any[]>(`${this.serverUrl}payment/get_iban_jm_notice_imports${query}`, this.httpOptions)
            .pipe(catchError(this.handleError));
    }

    getIbanJmNoticeImport(batchId: number) {
        return this.http
            .get<{ batch: any; payments: any[] }>(`${this.serverUrl}payment/get_iban_jm_notice_import/${batchId}`, this.httpOptions)
            .pipe(catchError(this.handleError));
    }

    /** Exec uploads a notice issuer Excel for a deal (stored in GED, batch pending validation). */
    uploadIbanJmNoticeBatch(formData: FormData) {
        return this.http
            .post<any>(`${this.serverUrl}payment/uploadNoticeBatch`, formData)
            .pipe(catchError(this.handleError));
    }

    /** Payment team validates a pending notice batch: creates payment rows and stores the WIRE CSV. */
    validateIbanJmNoticeBatch(batchId: number, request: {
        payments: Record<string, unknown>[];
        csv_content: string;
        csv_file_name?: string;
    }) {
        return this.http
            .post<any>(`${this.serverUrl}payment/validateNoticeBatch/${batchId}`, request, this.httpOptions)
            .pipe(catchError(this.handleError));
    }

    patchNoticeBatchNoticeTotal(batchId: number, noticeTotalAmount: number) {
        return this.http
            .post<{ batch: any }>(
                `${this.serverUrl}payment/patchNoticeBatchNoticeTotal/${batchId}`,
                { notice_total_amount: noticeTotalAmount },
                this.httpOptions,
            )
            .pipe(catchError(this.handleError));
    }

    /**
     * The notice batch page needs the status code to explain why the stored file is missing (gone
     * from the document store, forbidden, GED down), so these two keep the HttpErrorResponse
     * instead of the flat message handleError() rethrows. The body itself is unusable here: a blob
     * response turns the JSON error of the API into a Blob, not into error.error.message.
     */
    downloadIbanJmNoticeFile(batchId: number) {
        return this.http
            .get(`${this.serverUrl}payment/downloadNoticeFile/${batchId}`, { responseType: 'blob' })
            .pipe(catchError(this.rethrowHttpError));
    }

    downloadIbanJmNoticeCsv(batchId: number) {
        return this.http
            .get(`${this.serverUrl}payment/downloadNoticeCsv/${batchId}`, { responseType: 'blob' })
            .pipe(catchError(this.rethrowHttpError));
    }

    // Removed 2026-09-17: import_iban_jm() — local/import_iban_jm was deleted; the IBAN JM import parses the file in the browser and posts rows.

    get_iban_jm_by_deal(dealId: number | null, slugDeal?: string | null) {
        const slug = slugDeal ? `?slug_deal=${encodeURIComponent(slugDeal)}` : '';
        const id = dealId ?? 0;
        return this.http
            .get<any[]>(`${this.serverUrl}payment/get_iban_jm_by_deal/${id}${slug}`, this.httpOptions)
            .pipe(catchError(this.handleError));
    }

    validateIbanJm(id: number) {
        return this.http
            .post<any>(`${this.serverUrl}payment/validateIbanJm/${id}`, {}, this.httpOptions)
            .pipe(catchError(this.handleError));
    }

    rejectIbanJm(id: number, reason?: string) {
        return this.http
            .post<any>(`${this.serverUrl}payment/rejectIbanJm/${id}`, { reason }, this.httpOptions)
            .pipe(catchError(this.handleError));
    }

    get_iban_jm_deal_debit(dealId: number | null, slugDeal?: string | null) {
        const slug = slugDeal ? `?slug_deal=${encodeURIComponent(slugDeal)}` : '';
        const id = dealId ?? 0;
        return this.http
            .get<any>(`${this.serverUrl}payment_bank_account/get_deal_debit/${id}${slug}`, this.httpOptions)
            .pipe(catchError(this.handleError));
    }

    createIbanJmFromDeal(request: {
        deal_id: number | null;
        slug_deal: string | null;
        context_owners: { owner_type: string; owner_slug: string; owner_name?: string }[];
        beneficiary_account_id: number | null;
        payment_rail: string | null;
        amount: number | string | null;
        reference: string | null;
        motif: string | null;
        value_date: string;
        charges: string | null;
    }) {
        return this.http
            .post<any>(`${this.serverUrl}payment/createIbanJmFromDeal`, request, this.httpOptions)
            .pipe(catchError(this.handleError));
    }

    get_beneficiary_accounts_by_owners(
        owners: { owner_type: string; owner_slug: string; owner_name?: string }[],
        dealId: number | null,
        activeOnly = false,
    ) {
        return this.http
            .post<any[]>(`${this.serverUrl}payment_bank_account/list_by_owners`, {
                owners,
                active_only: activeOnly,
                deal_id: dealId,
            }, this.httpOptions)
            .pipe(catchError(this.handleError));
    }

    create_beneficiary_account(request: any) {
        return this.http
            .post<any>(`${this.serverUrl}payment_bank_account/create_beneficiary`, request, this.httpOptions)
            .pipe(catchError(this.handleError));
    }

    update_beneficiary_account(id: number, request: any) {
        return this.http
            .post<any>(`${this.serverUrl}payment_bank_account/update_beneficiary/${id}`, request, this.httpOptions)
            .pipe(catchError(this.handleError));
    }

    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_nb_pending_deal() {
        return this.http.get<[]>(this.serverUrl + 'local/get_nb_pending_deal')
            .pipe(
                catchError(this.handleError)
            );
    }

    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_dealBySlug(slug) {
        return this.http.get<[]>(this.serverUrl + 'local/get_dealBySlug/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_dealByCorporateSlug(slug) {
        return this.http.get<[]>(this.serverUrl + 'local/get_dealByCorporateSlug/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_dealByCorporateSlugSeparateTranche(slug) {
        return this.http.get<[]>(this.serverUrl + 'local/get_dealByCorporateSlugSeparateTranche/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_opportunity_by_slug_corporate(slug) {
        return this.http.get<[]>(this.serverUrl + 'local/get_opportunity_by_slug_corporate/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_all_opportunity_by_slug_corporate(slug) {
        return this.http.get<[]>(this.serverUrl + 'local/get_all_opportunity_by_slug_corporate/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_dealByCorporateSlugList(slug) {
        return this.http.get<[]>(this.serverUrl + 'local/get_dealByCorporateSlugList/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    add_deal(dealpost: any) {
        return this.http.post<any>(this.serverUrl + 'local/add_deal', dealpost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }


    /* Fonction distribution list */
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    addnewdistributionlist(distributionlist: any) {
        return this.http.post<any>(this.serverUrl + 'local/addnewdistributionlist', distributionlist, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_distributionlistbydeal(slug) {
        return this.http.get<[]>(this.serverUrl + 'local/get_distributionlistbydeal/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    envoimailaffectationdeal(execassignpost: any, slug: any) {
        const request = {
            execassignpost: execassignpost,
            slug
        }
        return this.http.post<any>(this.serverUrl + 'local/envoimailaffectationdeal', request, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    //unsed function at 14/01/2026 à 16h56
    envoimailnewdeallaunch(launchdealmailpost: any) {
        return this.http.post<any>(this.serverUrl + 'local/envoimailnewdeallaunch', launchdealmailpost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    //Unused code anywhere at 14/01/2026 à 16h56
    envoimailsupporttechinique(contactsupportpost: any) {
        return this.http.post<any>(this.serverUrl + 'local/envoimailsupporttechinique', contactsupportpost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    delete_deal(slug) {
        return this.http.post<any>(this.serverUrl + 'local/delete_deal/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    deletecashinterestcalendar_by_id(slug) {
        return this.http.post<any>(this.serverUrl + 'local/deletecashinterestcalendar_by_id/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    deletepikinterestcalendar_by_id(slug) {
        return this.http.post<any>(this.serverUrl + 'local/deletepikinterestcalendar_by_id/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    /*--------------------------*/

    /* Add bu */
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_bu() {
        return this.http.get<[]>(this.serverUrl + 'local/get_bu')
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_bu_principal() {
        return this.http.get<[]>(this.serverUrl + 'local/get_bu_principal')
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    add_bu(bupost: any) {
        return this.http.post<any>(this.serverUrl + 'local/add_bu', bupost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    delete_bu(slug) {
        return this.http.post<any>(this.serverUrl + 'local/delete_bu/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    /*--------------------------*/


    /* Add deal nature */
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_deal_nature() {
        return this.http.get<[]>(this.serverUrl + 'local/get_deal_nature')
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    add_deal_nature(bupost: any) {
        return this.http.post<any>(this.serverUrl + 'local/add_bu', bupost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    delete_deal_nature(slug) {
        return this.http.post<any>(this.serverUrl + 'local/delete_deal_nature/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    /* Service Sub Category */
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_deal_naturebybu(bu) {
        return this.http.get<[]>(this.serverUrl + 'local/get_deal_naturebybu/' + bu, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    /*--------------------------*/

    /* ROLE AFS BY LANDRY YEBOUA */
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_roles_user(group_id?: number) {
        // Endpoint backend: Local::get_roles_user() -> Api_model::get_roles_user()
        const url = group_id
            ? `${this.serverUrl}local/get_roles_user?group_id=${group_id}`
            : `${this.serverUrl}local/get_roles_user`;
        return this.http.get<any[]>(url, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    get_all_capabilities() {
        return this.http.get<any>(this.serverUrl + 'local/get_all_capabilities', this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    update_role_capabilities(groupId: number, capabilities: number[]) {
        return this.http.post<any>(this.serverUrl + 'local/update_role_capabilities', {
            group_id: groupId,
            capabilities: capabilities
        }, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    delete_capabilities(capabilityIds: number[]): Observable<any> {
        return this.http.post<any>(this.serverUrl + 'local/delete_capabilities', {
            capability_ids: capabilityIds
        }, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    check_capability_name_exists(name: string): Observable<any> {
        return this.http.post<any>(this.serverUrl + 'local/check_capability_name_exists', {
            name: name
        }, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    add_capability(capabilityData: any): Observable<any> {
        return this.http.post<any>(this.serverUrl + 'local/add_capability', capabilityData, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    update_capability(capabilityData: any): Observable<any> {
        return this.http.post<any>(this.serverUrl + 'local/update_capability', capabilityData, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    scan_html_files(): Observable<any> {
        return this.http.get<any>(this.serverUrl + 'local/scan_html_files', this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    get_current_user_profile(): Observable<any> {
        return this.http.get<any>(this.serverUrl + 'local/get_current_user_profile', this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    get_all_notifications(): Observable<any> {
        return this.http.get<any>(this.serverUrl + 'local/get_all_notifications', this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    update_user_profile(profileData: any): Observable<any> {
        return this.http.post<any>(this.serverUrl + 'local/update_user_profile', profileData, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    upload_user_profile_image(formData: FormData): Observable<any> {
        return this.http.post<any>(this.serverUrl + 'local/upload_user_profile_image', formData)
            .pipe(
                catchError(this.handleError)
            );
    }

    get_currency_by_bu(bu_slug: string): Observable<any> {
        return this.http.get<any>(this.serverUrl + 'local/get_currency_by_bu?bu_slug=' + encodeURIComponent(bu_slug), this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    get_role_afs() {
        // Endpoint backend: Local::get_afs_roles() -> Api_model::get_afs_roles()
        return this.http.get<[]>(this.serverUrl + 'local/get_afs_roles')
            .pipe(
                catchError(this.handleError)
            );
    }

    get_product_fees() {
        // Endpoint backend: Local::get_product_fees() -> Api_model::get_product_fees()
        return this.http.get<[]>(this.serverUrl + 'local/get_product_fees')
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_role_by_slug_bu_by_deal_by_active(slug, deal) {
        return this.http.get<[]>(this.serverUrl + 'crm/get_role_by_slug_bu_by_deal_by_active/' + slug + '/' + deal, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    add_role_afs(roleafspost: any) {
        return this.http.post<any>(this.serverUrl + 'local/add_role_afs', roleafspost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    check_role_afs_slug(slug: string, excludeId?: number) {
        let url = this.serverUrl + 'local/check_role_afs_slug/' + encodeURIComponent(slug);
        if (excludeId) {
            url += '/' + excludeId;
        }
        return this.http.get<any>(url, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    update_role_afs(request: any) {
        return this.http.post<any>(this.serverUrl + 'local/update_role_afs/' + request.id, request, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    delete_role_afs(slug) {
        return this.http.post<any>(this.serverUrl + 'local/delete_role_afs/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    check_product_fees_exists(billingcode: string, code_fr: string) {
        const data = {
            billingcode: billingcode,
            code_fr: code_fr || ''
        };
        return this.http.post<any>(this.serverUrl + 'local/check_product_fees_exists', data, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    add_product_fees(productfeespost: any) {
        return this.http.post<any>(this.serverUrl + 'local/add_product_fees', productfeespost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    update_product_fees(request: any) {
        return this.http.post<any>(this.serverUrl + 'local/update_product_fees/' + request.id, request, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    delete_product_fees(id) {
        return this.http.post<any>(this.serverUrl + 'local/delete_product_fees/' + id, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    /*--------------------------*/

    /* ROLE AFS BY LANDRY YEBOUA */
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_role_afs_tranche() {
        return this.http.get<[]>(this.serverUrl + 'local/get_role_afs_tranche')
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    add_role_afs_tranche(roleafstranchepost: any) {
        return this.http.post<any>(this.serverUrl + 'local/add_role_afs_tranche', roleafstranchepost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    delete_role_afs_tranche(slug) {
        return this.http.post<any>(this.serverUrl + 'local/delete_role_afs_tranche/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    /*--------------------------*/

    /* TYPE TRANCHE AFS BY LANDRY YEBOUA */
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_tranche_type() {
        return this.http.get<[]>(this.serverUrl + 'local/get_tranche_type')
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    add_tranche_type(typetranchepost: any) {
        return this.http.post<any>(this.serverUrl + 'local/add_tranche_type', typetranchepost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    delete_tranche_type(slug) {
        return this.http.post<any>(this.serverUrl + 'local/delete_tranche_type/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    /*--------------------------*/

    /* TYPE TRANCHE AFS BY LANDRY YEBOUA */
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_tranche_ranking() {
        return this.http.get<[]>(this.serverUrl + 'local/get_tranche_ranking')
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    add_tranche_ranking(rankingtranchepost: any) {
        return this.http.post<any>(this.serverUrl + 'local/add_tranche_ranking', rankingtranchepost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    delete_tranche_ranking(slug) {
        return this.http.post<any>(this.serverUrl + 'local/delete_tranche_ranking/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    /*--------------------------*/

    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_bank() {
        return this.http.get<[]>(this.serverUrl + 'local/get_bank')
            .pipe(
                catchError(this.handleError)
            );
    }

    /* CURRENCY BY LANDRY YEBOUA */
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_currency() {
        return this.http.get<[]>(this.serverUrl + 'local/get_currency')
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    add_currency(currencypost: any) {
        return this.http.post<any>(this.serverUrl + 'local/add_currency', currencypost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    delete_currency(slug) {
        return this.http.post<any>(this.serverUrl + 'local/delete_currency/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    /*--------------------------*/

    /* ISSUER ROLE WGL BY LANDRY YEBOUA */
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_role_issuer_wgl() {
        return this.http.get<[]>(this.serverUrl + 'local/get_role_issuer_wgl')
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    add_role_issuer_wgl(roleissuerwglpost: any) {
        return this.http.post<any>(this.serverUrl + 'local/add_role_issuer_wgl', roleissuerwglpost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    delete_role_issuer_wgl(slug) {
        return this.http.post<any>(this.serverUrl + 'local/delete_role_issuer_wgl/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    /*--------------------------*/


    /* ROLE THIRD PARTY ROLE WGL BY LANDRY YEBOUA */
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_role_thirdparty_wgl() {
        return this.http.get<[]>(this.serverUrl + 'local/get_role_thirdparty_wgl')
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    add_role_thirdparty_wgl(rolethirdpartywglpost: any) {
        return this.http.post<any>(this.serverUrl + 'local/add_role_thirdparty_wgl', rolethirdpartywglpost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    delete_role_thirdparty_wgl(slug) {
        return this.http.post<any>(this.serverUrl + 'local/delete_role_thirdparty_wgl/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    /*--------------------------*/


    /* SPECIFIC ROLE THIRD PARTY ROLE WGL BY LANDRY YEBOUA */
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_specific_role_thirdparty_wgl() {
        return this.http.get<[]>(this.serverUrl + 'local/get_specific_role_thirdparty_wgl')
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    add_specific_role_thirdparty_wgl(specificrolethirdpartywglpost: any) {
        return this.http.post<any>(this.serverUrl + 'local/add_specific_role_thirdparty_wgl', specificrolethirdpartywglpost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    delete_specific_role_thirdparty_wgl(slug) {
        return this.http.post<any>(this.serverUrl + 'local/delete_specific_role_thirdparty_wgl/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    /*--------------------------*/

    /* SPECIFIC ROLE AFS BY LANDRY YEBOUA */
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_specific_role_afs() {
        return this.http.get<[]>(this.serverUrl + 'local/get_specific_role_afs')
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    add_specific_role_afs(specificrolethirdpartywglpost: any) {
        return this.http.post<any>(this.serverUrl + 'local/add_specific_role_afs', specificrolethirdpartywglpost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    delete_specific_role_afs(slug) {
        return this.http.post<any>(this.serverUrl + 'local/delete_specific_role_afs/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    /*--------------------------*/

    /* TRANCHE BY LANDRY YEBOUA */
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_tranche() {
        return this.http.get<[]>(this.serverUrl + 'local/get_tranche')
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_instrumentbyslugdeal(slug) {
        return this.http.get<[]>(this.serverUrl + 'local/get_instrumentbyslugdeal/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_tranchebyslugdealwherepaymentexist(slug) {
        return this.http.get<[]>(this.serverUrl + 'local/get_tranchebyslugdealwherepaymentexist/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_maxtranchebyslugdeal(slug) {
        return this.http.get<[]>(this.serverUrl + 'local/get_maxtranchebyslugdeal/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    /** Alias pour get_maxtranchebyslugdeal (staging) */
    get_tranchebyslugdeal(slug) {
        return this.get_maxtranchebyslugdeal(slug);
    }


    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_tranchebyDealbynumtranche(slug, deal) {
        return this.http.get<any>(this.serverUrl + 'local/get_tranchebyDealbynumtranche/' + slug + '/' + deal, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_actual_info(slug, deal) {
        return this.http.get<[]>(this.serverUrl + 'registre/get_actual_info/' + deal + '/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getdrawdownByCurrency(slug, deal) {
        return this.http.get<[]>(this.serverUrl + 'registre/getdrawdownByCurrency/' + slug + '/' + deal, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }



    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_instrumentbyDealbyidinstrument(slug, deal) {
        return this.http.get<[]>(this.serverUrl + 'local/get_instrumentbyDealbyidinstrument/' + slug + '/' + deal, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    export_portfolio_info(data: any) {
        return this.http.post<any>(this.serverUrl + 'crm_report/export_portfolio_info', data, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    add_tranche(tranchepost: any) {
        return this.http.post<any>(this.serverUrl + 'tranches/add_tranche', tranchepost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    add_instrument(any: any) {
        return this.http.post<any>(this.serverUrl + 'local/add_instrument', any, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    // function delete_clause_deal
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    delete_clause_deal(slug_deal, slug_clause_deal) {
        return this.http.post<any>(this.serverUrl + 'local/delete_clause_deal/' + slug_deal + '/' + slug_clause_deal, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    delete_tranche(slug) {
        return this.http.post<any>(this.serverUrl + 'local/delete_tranche/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    delete_instrument(slug) {
        return this.http.post<any>(this.serverUrl + 'local/delete_instrument/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    /*--------------------------*/

    /*-----------------*/
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_tranchebyslugtranchebyDate(slug, date) {
        return this.http.get<[]>(this.serverUrl + 'local/get_tranchebyslugtranchebyDate/' + slug + '/' + date, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_tranchebyslugtranche(slug) {
        return this.http.get<[]>(this.serverUrl + 'local/get_tranchebyslugtranche/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_tranchebyslugtrancheseul(slug) {
        return this.http.get<[]>(this.serverUrl + 'local/get_tranchebyslugtrancheseul/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }


    /*------------*/

    /* BILLING INFORMATION BY LANDRY YEBOUA */
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_deal_billing_information() {
        return this.http.get<[]>(this.serverUrl + 'local/get_deal_billing_information')
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    add_deal_billing_information(dealbillinginformationpost: any) {
        return this.http.post<any>(this.serverUrl + 'local/add_deal_billing_information', dealbillinginformationpost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    delete_deal_billing_information(slug) {
        return this.http.post<any>(this.serverUrl + 'local/delete_deal_billing_information/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    /*--------------------------*/


    /* USER BY LANDRY YEBOUA */
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_users() {
        return this.http.get<any[]>(this.serverUrl + 'local/get_users')
            .pipe(
                catchError(this.handleError)
            );
    }

    get_users_by_bu(bu: string) {
        return this.http.get<any[]>(this.serverUrl + 'local/get_users_by_bu/' + bu)
            .pipe(
                catchError(this.handleError)
            );
    }
    /* USER BY LANDRY YEBOUA */
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_users_exec() {
        return this.http.get<[]>(this.serverUrl + 'local/get_users_exec')
            .pipe(
                catchError(this.handleError)
            );
    }
    /* USER BY LANDRY YEBOUA */
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_users_busdev() {
        return this.http.get<[]>(this.serverUrl + 'local/get_users_busdev')
            .pipe(
                catchError(this.handleError)
            );
    }
    /*----------------------------*/

    /** Délègue à Company (company/get_corporate_contact_by_slug). Préférer CompanyService.get_corporate_contact_by_id si vous avez corporate_id. */
    get_corporate_contact_by_slug(slug) {
        return this.http.get<[]>(this.serverUrl + 'company/get_corporate_contact_by_slug/' + encodeURIComponent(slug), this.httpOptions)
            .pipe(catchError(this.handleError));
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_all_base_rate_by_currency(currency) {
        return this.http.get<[]>(this.serverUrl + 'local/get_all_base_rate_by_currency/' + currency, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    /*----------------------------*/



    /* SPECIFIC ROLE AFS BY LANDRY YEBOUA */
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_deal_wgl_issuer() {
        return this.http.get<[]>(this.serverUrl + 'local/get_deal_wgl_issuer')
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    add_deal_wgl_issuer(wgldealissuersidepost: any) {
        return this.http.post<any>(this.serverUrl + 'local/add_deal_wgl_issuer', wgldealissuersidepost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    add_deal_wgl_investor(wgldealinvestorsidepost: any) {
        return this.http.post<any>(this.serverUrl + 'local/add_deal_wgl_investor', wgldealinvestorsidepost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    add_deal_wgl_investor_lawyer(wgldealinvestorlawyerpost: any) {
        return this.http.post<any>(this.serverUrl + 'local/add_deal_wgl_investor_lawyer', wgldealinvestorlawyerpost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    add_deal_wgl_third_party(wgldealthirdpartypost: any) {
        return this.http.post<any>(this.serverUrl + 'local/add_deal_wgl_third_party', wgldealthirdpartypost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    delete_deal_wgl_issuer(slug) {
        return this.http.post<any>(this.serverUrl + 'local/delete_deal_wgl_issuer/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    delete_deal_wgl_investors(slug) {
        return this.http.post<any>(this.serverUrl + 'local/delete_deal_wgl_investors/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    delete_deal_wgl_investors_lawyer(slug) {
        return this.http.post<any>(this.serverUrl + 'local/delete_deal_wgl_investors_lawyer/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    delete_deal_wgl_thirdparty(slug) {
        return this.http.post<any>(this.serverUrl + 'local/delete_deal_wgl_thirdparty/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    /*--------------------------*/

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    execCreateNewDeal(opportunitypost: any) {
        return this.http.post<any>(this.serverUrl + 'crm_opportunity/execCreateNewDeal', opportunitypost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    createClause(clausepost: any) {
        return this.http.post<any>(this.serverUrl + 'local/createClause', clausepost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    createListDistributionList(listdistributionlistpost: any) {
        return this.http.post<any>(this.serverUrl + 'local/createListDistributionList', listdistributionlistpost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    inserttoclausecalendar(clausepost: any) {
        return this.http.post<any>(this.serverUrl + 'local/inserttoclausecalendar', clausepost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    inserttocouponcalendar(couponpost: any) {
        return this.http.post<any>(this.serverUrl + 'local/inserttocouponcalendar', couponpost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    inserttocashinterestcalendar(any: any) {
        return this.http.post<any>(this.serverUrl + 'local/inserttocashinterestcalendar', any, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    inserttopikinterestcalendar(any: any) {
        return this.http.post<any>(this.serverUrl + 'local/inserttopikinterestcalendar', any, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    inserttocommitmentcalendar(any: any) {
        return this.http.post<any>(this.serverUrl + 'local/inserttocommitmentcalendar', any, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    deleteoncashinterestcalendar(any: any) {
        return this.http.post<any>(this.serverUrl + 'local/deleteoncashinterestcalendar', any, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    deleteonpikinterestcalendar(any: any) {
        return this.http.post<any>(this.serverUrl + 'local/deleteonpikinterestcalendar', any, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    deleteoncommitmentcalendar(any: any) {
        return this.http.post<any>(this.serverUrl + 'local/deleteoncommitmentcalendar', any, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    inserttofinancialdocumentcalendar(couponpost: any) {
        return this.http.post<any>(this.serverUrl + 'local/inserttofinancialdocumentcalendar', couponpost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    inserttovaloreportingcalendar(couponpost: any) {
        return this.http.post<any>(this.serverUrl + 'local/inserttovaloreportingcalendar', couponpost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    inserttosecuritycalendar(securitycalendarpost: any) {
        return this.http.post<any>(this.serverUrl + 'local/inserttosecuritycalendar', securitycalendarpost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    createCoupons(couponspost: any) {
        return this.http.post<any>(this.serverUrl + 'local/createCoupons', couponspost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    createFinancialMonitoringCalendar(couponspost: any) {
        return this.http.post<any>(this.serverUrl + 'local/createFinancialMonitoringCalendar', couponspost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    createValoReportingCalendar(couponspost: any) {
        return this.http.post<any>(this.serverUrl + 'local/createValoReportingCalendar', couponspost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    createClauseDeal(clausepost: any) {
        return this.http.post<any>(this.serverUrl + 'local/createClauseDeal', clausepost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    createEvent(eventpost: any) {
        return this.http.post<any>(this.serverUrl + 'local/createEvent', eventpost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    addProjectLostDetail(projectlostpost: any) {
        return this.http.post<any>(this.serverUrl + 'local/addProjectLostDetail', projectlostpost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    add_to_rat(any: any) {
        return this.http.post<any>(this.serverUrl + 'local/add_to_rat', any, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    create_file_folder_external_access_deal(filefolderpost: any) {
        return this.http.post<any>(this.serverUrl + 'local/create_file_folder_external_access_deal', filefolderpost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_all_file_folder_external_access_by_deal(identifiant) {
        return this.http.get<[]>(this.serverUrl + 'local/get_all_file_folder_external_access_by_deal/' + identifiant)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    cashinterest_calendar_detail(slug_tranche) {
        return this.http.get<[]>(this.serverUrl + 'local/cashinterest_calendar_detail/' + slug_tranche)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    pikinterest_calendar_detail(slug_tranche) {
        return this.http.get<[]>(this.serverUrl + 'local/pikinterest_calendar_detail/' + slug_tranche)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    commitmentfee_calendar_detail(slug_tranche) {
        return this.http.get<[]>(this.serverUrl + 'local/commitmentfee_calendar_detail/' + slug_tranche)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_all_file_folder_external_access_by_deal_global(identifiant) {
        return this.http.get<[]>(this.serverUrl + 'local/get_all_file_folder_external_access_by_deal_global/' + identifiant)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    // unsed function at 14/01/2025 at 17H00
    send_notification_add_file_to_deal(identifiant) {
        return this.http.get<[]>(this.serverUrl + 'local/send_notification_add_file_to_deal/' + identifiant)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_all_file_folder_external_access_by_deal_by_name(identifiant, name) {
        return this.http.get<[]>(this.serverUrl + 'local/get_all_file_folder_external_access_by_deal_by_name/' + identifiant + '/' + name)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    createClauseCalendarProcess(clausecalendarpost: any) {
        return this.http.post<any>(this.serverUrl + 'local/createClauseCalendarProcess', clausecalendarpost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    createSecurityProcess(securityhandlingpost: any) {
        return this.http.post<any>(this.serverUrl + 'local/createSecurityProcess', securityhandlingpost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }


    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    updateClauseCalendarProcess(clausecalendarpost: any, id) {
        return this.http.post<any>(this.serverUrl + 'local/updateClauseCalendarProcess/' + id, clausecalendarpost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    updateClauseCalendarValidate(id) {
        return this.http.post<any>(this.serverUrl + 'local/updateClauseCalendarValidate/' + id, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    updateClauseModifyDateCalendar(id, date) {
        return this.http.post<any>(this.serverUrl + 'local/updateClauseModifyDateCalendar/' + id + '/' + date, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    renameprojectname(id, data: any) {
        return this.http.post<any>(this.serverUrl + 'local/renameprojectname/' + id, data, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    updateCouponsModifyDateCalendar(id, date) {
        return this.http.post<any>(this.serverUrl + 'local/updateCouponsModifyDateCalendar/' + id + '/' + date, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    updateFinancialMonitoringModifyDateCalendar(id, date) {
        return this.http.post<any>(this.serverUrl + 'local/updateFinancialMonitoringModifyDateCalendar/' + id + '/' + date, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    updateValoReportingModifyDateCalendar(id, date) {
        return this.http.post<any>(this.serverUrl + 'local/updateValoReportingModifyDateCalendar/' + id + '/' + date, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    updateCouponsCalendarValidate(id) {
        return this.http.post<any>(this.serverUrl + 'local/updateCouponsCalendarValidate/' + id, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    updateFinancialMonitoringCalendarValidate(id) {
        return this.http.post<any>(this.serverUrl + 'local/updateFinancialMonitoringCalendarValidate/' + id, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    updateReportingCalendarValidate(id) {
        return this.http.post<any>(this.serverUrl + 'local/updateReportingCalendarValidate/' + id, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    updateClauseCalendarSendMail(id) {
        return this.http.post<any>(this.serverUrl + 'local/updateClauseCalendarSendMail/' + id, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    updateSecuritySendMail(id) {
        return this.http.post<any>(this.serverUrl + 'local/updateSecuritySendMail/' + id, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    updateSecurityProcess(id, securityhandlingpost: any) {
        return this.http.post<any>(this.serverUrl + 'local/updateSecurityProcess/' + id, securityhandlingpost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    createClauseCalendarSendTracking(clausecalendarpost: any) {
        return this.http.post<any>(this.serverUrl + 'local/createClauseCalendarSendTracking', clausecalendarpost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    createSecuritySendTracking(securityhandlingpost: any) {
        return this.http.post<any>(this.serverUrl + 'local/createSecuritySendTracking', securityhandlingpost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    createSecurity(securitypost: any) {
        return this.http.post<any>(this.serverUrl + 'local/createSecurity', securitypost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }






    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_detailDistributionList_by_deal(slug, id) {
        return this.http.get<[]>(this.serverUrl + 'local/get_detailDistributionList_by_deal/' + slug + '/' + id, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getRenewalCalendarByDealByTranche(slug, tranche) {
        return this.http.get<[]>(this.serverUrl + 'local/getRenewalCalendarByDealByTranche/' + slug + '/' + tranche, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getRenewalCalendarByDeal(slug) {
        return this.http.get<[]>(this.serverUrl + 'local/getRenewalCalendarByDeal/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getClauseCalendarProcessByIdCalendar(slug) {
        return this.http.get<[]>(this.serverUrl + 'local/getClauseCalendarProcessByIdCalendar/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getDistribListClauseCalendarProcessByIdCalendar(slug) {
        return this.http.get<[]>(this.serverUrl + 'local/getDistribListClauseCalendarProcessByIdCalendar/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getDistribListClauseCalendarProcessByIdCalendarLast(slug) {
        return this.http.get<[]>(this.serverUrl + 'local/getDistribListClauseCalendarProcessByIdCalendarLast/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getDistribListSecurityProcessById(slug) {
        return this.http.get<[]>(this.serverUrl + 'local/getDistribListSecurityProcessById/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getNextReviewByDealByTranche(slug, tranche) {
        return this.http.get<[]>(this.serverUrl + 'local/getNextReviewByDealByTranche/' + slug + '/' + tranche, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getNextReviewByDeal(slug) {
        return this.http.get<[]>(this.serverUrl + 'local/getNextReviewByDeal/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_security_calendar(slug) {
        return this.http.get<[]>(this.serverUrl + 'local/get_security_calendar/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getAllSecurityByDealByTranche(slug, tranche) {
        return this.http.get<[]>(this.serverUrl + 'local/getAllSecurityByDealByTranche/' + slug + '/' + tranche, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getAllSecurityByDeal(slug) {
        return this.http.get<[]>(this.serverUrl + 'local/getAllSecurityByDeal/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getSecurityHandlingByDeal(slug) {
        return this.http.get<[]>(this.serverUrl + 'local/getSecurityHandlingByDeal/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getAllSecurity() {
        return this.http.get<[]>(this.serverUrl + 'local/getAllSecurity', this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getSecurityByDealByTrancheById(slug, id) {
        return this.http.get<[]>(this.serverUrl + 'local/getSecurityByDealByTrancheById/' + slug + '/' + id, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getAllSecurityType() {
        return this.http.get<[]>(this.serverUrl + 'local/getAllSecurityType', this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getAllClauseType() {
        return this.http.get<[]>(this.serverUrl + 'local/getAllClauseType', this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getClauseByMonth(month) {
        return this.http.get<[]>(this.serverUrl + 'local/getClauseByMonth/' + month, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getSecuritiesByMonth(month) {
        return this.http.get<[]>(this.serverUrl + 'local/getSecuritiesByMonth/' + month, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    delete_security(id) {
        return this.http.post<any>(this.serverUrl + 'local/delete_security/' + id, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    delete_distributionlist(id) {
        return this.http.post<any>(this.serverUrl + 'local/delete_distributionlist/' + id, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    deleteEvent(id) {
        return this.http.post<any>(this.serverUrl + 'local/deleteEvent/' + id, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }


    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    delete_coupons(id, slug) {
        return this.http.post<any>(this.serverUrl + 'local/delete_coupons/' + id + '/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    delete_financial_monitoring(id, slug) {
        return this.http.post<any>(this.serverUrl + 'local/delete_financial_monitoring/' + id + '/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    delete_valo_reporting(id, slug) {
        return this.http.post<any>(this.serverUrl + 'local/delete_valo_reporting/' + id + '/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    delete_clause(id, slug) {
        return this.http.post<any>(this.serverUrl + 'local/delete_clause/' + id + '/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    delete_clause_calendar(slug) {
        return this.http.post<any>(this.serverUrl + 'local/delete_clause_calendar/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getClauseCalendarByDealByTranche(slug, tranche) {
        return this.http.get<[]>(this.serverUrl + 'local/getClauseCalendarByDealByTranche/' + slug + '/' + tranche, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getCouponsCalendarByDealByCoupons(slug, tranche) {
        return this.http.get<[]>(this.serverUrl + 'local/getCouponsCalendarByDealByCoupons/' + slug + '/' + tranche, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getFinancialMonitoringCalendarByDealByFM(slug, tranche) {
        return this.http.get<[]>(this.serverUrl + 'local/getFinancialMonitoringCalendarByDealByFM/' + slug + '/' + tranche, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getValoReportingCalendarByDealByFM(slug, tranche) {
        return this.http.get<[]>(this.serverUrl + 'local/getValoReportingCalendarByDealByFM/' + slug + '/' + tranche, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getAllClauseCalendar() {
        return this.http.get<[]>(this.serverUrl + 'local/getAllClauseCalendar', this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getAllClauseCalendarDashboard() {
        return this.http.get<[]>(this.serverUrl + 'local/getAllClauseCalendarDashboard', this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getAllClauseCalendarDashboardByDeal(slug) {
        return this.http.get<[]>(this.serverUrl + 'local/getAllClauseCalendarDashboardByDeal/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getAllClauseCalendarDashboardByDealByTranche(slug, tranche) {
        return this.http.get<[]>(this.serverUrl + 'local/getAllClauseCalendarDashboardByDealByTranche/' + slug + '/' + tranche, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getAllClauseCalendarDashboardByUser(slug) {
        return this.http.get<[]>(this.serverUrl + 'local/getAllClauseCalendarDashboardByUser/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getClauseCalendarByDeal(slugdeal) {
        return this.http.get<[]>(this.serverUrl + 'local/getClauseCalendarByDeal/' + slugdeal, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getClauseCalendarByDealAll(slugdeal) {
        return this.http.get<[]>(this.serverUrl + 'local/getClauseCalendarByDealAll/' + slugdeal, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getCouponsCalendarByDeal(slugdeal) {
        return this.http.get<[]>(this.serverUrl + 'local/getCouponsCalendarByDeal/' + slugdeal, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getCouponsCalendarByUser(slug) {
        return this.http.get<[]>(this.serverUrl + 'local/getCouponsCalendarByUser/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getCouponsNewCalendarByUser(slug) {
        return this.http.get<[]>(this.serverUrl + 'execution/getCouponsNewCalendarByUser/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getCouponsNewCalendar() {
        return this.http.get<[]>(this.serverUrl + 'local/getCouponsNewCalendar', this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    getCouponsNewCalendarFiltered(filters: {
        exec_in_charge?: string | null;
        supervisor?: string | null;
        start_date?: string | null;
        end_date?: string | null;
    }) {
        return this.http.post<[]>(this.serverUrl + 'execution/getCouponsNewCalendarFiltered', filters, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getValoFinancialMonitoringCalendarByUser(slug) {
        return this.http.get<[]>(this.serverUrl + 'local/getValoFinancialMonitoringCalendarByUser/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getValoReportingCalendarByUser(slug) {
        return this.http.get<[]>(this.serverUrl + 'local/getValoReportingCalendarByUser/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getCouponsCalendarBySlugCoupons(slug) {
        return this.http.get<[]>(this.serverUrl + 'local/getCouponsCalendarBySlugCoupons/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getFinancialMonitoringCalendarBySlugFM(slug) {
        return this.http.get<[]>(this.serverUrl + 'local/getFinancialMonitoringCalendarBySlugFM/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getValoReportingCalendarBySlugFM(slug) {
        return this.http.get<[]>(this.serverUrl + 'local/getValoReportingCalendarBySlugFM/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getCouponsCalendar() {
        return this.http.get<[]>(this.serverUrl + 'local/getCouponsCalendar/', this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getCouponsCalendarByDealLimitNew(slugdeal, numtranche = null) {
        return this.http.get<[]>(`${this.serverUrl}local/getCouponsCalendarByDealLimitNew/${slugdeal}/${numtranche}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getCouponsCalendarByDealLimit(slugdeal, numtranche = null) {
        return this.http.get<[]>(`${this.serverUrl}local/getCouponsCalendarByDealLimit/${slugdeal}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getValoReportingCalendarByDealLimit(slugdeal) {
        return this.http.get<[]>(this.serverUrl + 'local/getValoReportingCalendarByDealLimit/' + slugdeal, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getValoFinancialMonitoringByDealLimit(slugdeal) {
        return this.http.get<[]>(this.serverUrl + 'local/getValoFinancialMonitoringByDealLimit/' + slugdeal, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getCouponsCalendarByDealAll(slugdeal) {
        return this.http.get<[]>(this.serverUrl + 'local/getCouponsCalendarByDealAll/' + slugdeal, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getCovenantChartDataNew(deal, corpo) {
        return this.http.get<[]>(this.serverUrl + 'local/getCovenantChartDataNew/' + deal + '/' + corpo, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getCovenantChartCorpo(corpo) {
        return this.http.get<[]>(this.serverUrl + 'local/getCovenantChartCorpo/' + corpo, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getCovenantChartCorpo2(corpo) {
        return this.http.get<[]>(this.serverUrl + 'local/getCovenantChartCorpo2/' + corpo, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getClauseByDealByTranche(slug, tranche) {
        return this.http.get<[]>(this.serverUrl + 'local/getClauseByDealByTranche/' + slug + '/' + tranche, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getClauseDetailByDealByTranche(slug, tranche) {
        return this.http.get<[]>(this.serverUrl + 'local/getClauseDetailByDealByTranche/' + slug + '/' + tranche, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getClauseByDealByTrancheLimit(slug, tranche) {
        return this.http.get<[]>(this.serverUrl + 'local/getClauseByDealByTrancheLimit/' + slug + '/' + tranche, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getCouponByTrancheLimit(slug, tranche) {
        return this.http.get<[]>(this.serverUrl + 'local/getCouponByTrancheLimit/' + slug + '/' + tranche, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getCouponByTrancheLimitPayed(slug, tranche) {
        return this.http.get<[]>(this.serverUrl + 'local/getCouponByTrancheLimitPayed/' + slug + '/' + tranche, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getCouponByDealLimitPayed(slug, numtranche = null) {
        return this.http.get<[]>(this.serverUrl + 'local/getCouponByDealLimitPayed/' + slug + '/' + numtranche, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getClauseByDeal(slug) {
        return this.http.get<[]>(this.serverUrl + 'local/getClauseByDeal/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getAllCouponsByDeal(slug) {
        return this.http.get<any>(this.serverUrl + 'local/getAllCouponsByDeal/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getAllFinancialMonitoringCalendarByDeal(slug) {
        return this.http.get<[]>(this.serverUrl + 'local/getAllFinancialMonitoringCalendarByDeal/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getAllReportingCalendarByDeal(slug) {
        return this.http.get<[]>(this.serverUrl + 'local/getAllReportingCalendarByDeal/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getcouponsdetail(slug) {
        return this.http.get<[]>(this.serverUrl + 'local/getcouponsdetail/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getListInvestorByCompany(slug) {
        return this.http.get<[]>(this.serverUrl + 'registre/getListInvestorByCompany/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getfinancialmonitoringdetail(slug) {
        return this.http.get<[]>(this.serverUrl + 'local/getfinancialmonitoringdetail/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }


    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getreportingcalendardetail(slug) {
        return this.http.get<[]>(this.serverUrl + 'local/getreportingcalendardetail/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getAllCouponsByDealLimit(slug) {
        return this.http.get<[]>(this.serverUrl + 'local/getAllCouponsByDealLimit/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getAllClauseByCorpo(slug) {
        return this.http.get<[]>(this.serverUrl + 'local/getAllClauseByCorpo/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getAllClauseByCorpoWithRelevant(slug, identifiant) {
        return this.http.get<[]>(this.serverUrl + 'local/getAllClauseByCorpoWithRelevant/' + slug + '/' + identifiant, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getAllClauseByCorpoWithRelevantNotUsed(slug, identifiant) {
        return this.http.get<[]>(this.serverUrl + 'local/getAllClauseByCorpoWithRelevantNotUsed/' + slug + '/' + identifiant, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getAllClauseByCorpoByClause(slug, clause) {
        return this.http.get<[]>(this.serverUrl + 'local/getAllClauseByCorpoByClause/' + slug + '/' + clause, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getClauseByDealLimit(slug) {
        return this.http.get<[]>(this.serverUrl + 'local/getClauseByDealLimit/' + slug, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getAllClauseCalendarDashboardNumNonTraite() {
        return this.http.get<any>(this.serverUrl + 'local/getAllClauseCalendarDashboardNumNonTraite', this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getAllCouponsCalendarDashboardNumNonTraite() {
        return this.http.get<any>(this.serverUrl + 'local/getAllCouponsCalendarDashboardNumNonTraite', this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getAllValoFinancialMonitoringCalendarDashboardNumNonTraite() {
        return this.http.get<any>(this.serverUrl + 'local/getAllValoFinancialMonitoringCalendarDashboardNumNonTraite', this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getAllValoReportingCalendarDashboardNumNonTraite() {
        return this.http.get<any>(this.serverUrl + 'local/getAllValoReportingCalendarDashboardNumNonTraite', this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getAllRatData() {
        return this.http.get<any>(this.serverUrl + 'local/getAllRatData', this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getClauseCalendarByDealByTrancheByClause(slug, tranche, clause) {
        return this.http.get<[]>(this.serverUrl + 'local/getClauseCalendarByDealByTrancheByClause/' + slug + '/' + clause, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getClauseByDealByTrancheByClause(slug, clause, idelement) {
        return this.http.get<[]>(this.serverUrl + 'local/getClauseByDealByTrancheByClause/' + slug + '/' + clause + '/' + idelement, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getClauseBySlugClauseDeal(slug, clause) {
        return this.http.get<[]>(this.serverUrl + 'local/getClauseBySlugClauseDeal/' + slug + '/' + clause, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_tranchebyDealbyClause(slug, clause) {
        return this.http.get<[]>(this.serverUrl + 'local/get_tranchebyDealbyClause/' + slug + '/' + clause, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getClauseByDealByTrancheByClauseid(slug, tranche, clause) {
        return this.http.get<[]>(this.serverUrl + 'local/getClauseByDealByTrancheByClauseid/' + slug + '/' + tranche + '/' + clause, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    update_security(securitypost: any, id) {
        return this.http.post<any>(this.serverUrl + 'local/update_security/' + id, securitypost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    update_cashinterestcalendar(cashinterescalendarpost: any, id) {
        return this.http.post<any>(this.serverUrl + 'local/update_cashinterestcalendar/' + id, cashinterescalendarpost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    update_pikinterestcalendar(cashinterescalendarpost: any, id) {
        return this.http.post<any>(this.serverUrl + 'local/update_pikinterestcalendar/' + id, cashinterescalendarpost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    update_tranche(tranchepost: any, id) {
        return this.http.post<any>(this.serverUrl + 'local/update_tranche/' + id, tranchepost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    update_nominalvalue_nbof_unit_of_tranche(tranchepost: any) {
        return this.http.post<any>(this.serverUrl + 'local/update_nominalvalue_nbof_unit_of_tranche', tranchepost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    update_instrument(any: any, id) {
        return this.http.post<any>(this.serverUrl + 'local/update_instrument/' + id, any, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    updateClause(clausepost: any, id) {
        return this.http.post<any>(this.serverUrl + 'local/updateClause/' + id, clausepost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    updateClauseDeal(id, clausepost: any) {
        return this.http.post<any>(this.serverUrl + 'local/updateClauseDeal/' + id, clausepost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    updateclause(clausepost: any, id, firstduedate, lastduedate, slug) {
        return this.http.post<any>(this.serverUrl + 'local/update_clause/' + id + '/' + firstduedate + '/' + lastduedate + '/' + slug, clausepost, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_notification_by_user(slug) {
        return this.http.get<[]>(this.serverUrl + 'local/get_notification_by_user/' + slug, this.httpOptions)
            .pipe(
                tap(data => {
                    // debug error here

                }),
                catchError(this.handleError)
            );
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    createNotification(any: any) {
        return this.http.post<any>(this.serverUrl + 'local/createNotification', any, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    update_notification(any: any, id) {
        return this.http.post<any>(this.serverUrl + 'local/update_notification/' + id, any, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    // Removed 2026-09-17: adddocumenttodeal() — local/adddocumenttodeal was deleted (wrote to assets/arturdocs/, no component called it).

    private getEventMessage(event: HttpEvent<any>) {
        switch (event.type) {
            case HttpEventType.UploadProgress:
                const percentDone = Math.round(
                    (100 * event.loaded) / (event.total || 1)
                );
                return { status: 'progress', progress: percentDone };

            case HttpEventType.Response:
                return { status: 'done', body: event.body };

            default:
                return { status: 'other', event };
        }
    }

    //EQUIPEMENT IT
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_equipement() {
        return this.http
            .get<[]>(this.serverUrl + 'local/get_equipement', this.httpOptions)
            .pipe(catchError(this.handleError));
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    // Removed 2026-09-17: add_equipement() — local/add_equipement was deleted (wrote to assets/inventory_afs/, no component called it).

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    // Removed 2026-09-17: add_equipement_with_2_images() — no such endpoint has ever existed.

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    // Removed 2026-09-17: add_equipement_with_3_images() — no such endpoint has ever existed.

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    add_equipement_without_image(formData) {
        return this.http
            .post<any>(
                `${this.serverUrl}local/add_equipement_without_image`,
                formData,
                {
                    reportProgress: true,
                    observe: 'events',
                }
            )
            .pipe(catchError(this.handleError));
    }

    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_equipement_history() {
        return this.http
            .get<
                []
            >(this.serverUrl + 'local/get_equipement_history', this.httpOptions)
            .pipe(catchError(this.handleError));
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    switch_user_equipement(any: any, id) {
        return this.http
            .post<any>(
                this.serverUrl + 'local/switch_user_equipement/' + id,
                any,
                this.httpOptions
            )
            .pipe(catchError(this.handleError));
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    delete_equipement(id) {
        return this.http
            .post<any>(
                this.serverUrl + 'local/delete_equipement/' + id,
                this.httpOptions
            )
            .pipe(catchError(this.handleError));
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    delete_history_equipement(id) {
        return this.http
            .post<any>(
                this.serverUrl + 'local/delete_history_equipement/' + id,
                this.httpOptions
            )
            .pipe(catchError(this.handleError));
    }

    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_equipement_filtre(colonne, filtre) {
        return this.http
            .get<any>(
                this.serverUrl +
                'local/get_equipement_filtre/' +
                colonne +
                '/' +
                filtre,
                this.httpOptions
            )
            .pipe(catchError(this.handleError));
    }

    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_checklist_it() {
        return this.http
            .get<[]>(this.serverUrl + 'local/get_checklist_it', this.httpOptions)
            .pipe(catchError(this.handleError));
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_checklist_by_id(id) {
        return this.http
            .get<
                []
            >(this.serverUrl + 'local/get_checklist_by_id/' + id, this.httpOptions)
            .pipe(catchError(this.handleError));
    }

    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_checklist_it_inactif() {
        return this.http
            .get<
                []
            >(this.serverUrl + 'local/get_checklist_it_inactif', this.httpOptions)
            .pipe(catchError(this.handleError));
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_user() {
        return this.http
            .get<[]>(this.serverUrl + 'local/get_user', this.httpOptions)
            .pipe(catchError(this.handleError));
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_user_actif() {
        return this.http
            .get<[]>(this.serverUrl + 'local/get_user_actif', this.httpOptions)
            .pipe(catchError(this.handleError));
    }

    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_user_inactif() {
        return this.http
            .get<[]>(this.serverUrl + 'local/get_user_inactif', this.httpOptions)
            .pipe(catchError(this.handleError));
    }

    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_group() {
        return this.http
            .get<[]>(this.serverUrl + 'local/get_group', this.httpOptions)
            .pipe(catchError(this.handleError));
    }

    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_group_user(id) {
        return this.http
            .get<[]>(this.serverUrl + 'local/get_group_user/' + id, this.httpOptions)
            .pipe(catchError(this.handleError));
    }

    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_nb_equipement_by_type(type) {
        return this.http
            .get<
                []
            >(this.serverUrl + 'local/get_nb_equipement_by_type/' + type, this.httpOptions)
            .pipe(catchError(this.handleError));
    }

    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_nb_equipement_autres() {
        return this.http
            .get<
                []
            >(this.serverUrl + 'local/get_nb_equipement_autres', this.httpOptions)
            .pipe(catchError(this.handleError));
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    adduser(access: any) {
        return this.http
            .post<any>(
                this.serverUrl + 'local/add_user',
                access,
                this.httpOptions
            )
            .pipe(catchError(this.handleError));
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    sendbymail(sendp: any) {
        return this.http
            .post<any>(
                this.serverUrl + 'local/sendbymail',
                sendp,
                this.httpOptions
            )
            .pipe(catchError(this.handleError));
    }

    sendbyemailAppointment(sendp: any) {
        return this.http
            .post<any>(
                this.serverUrl + 'local/sendbyemailAppointment',
                sendp,
                this.httpOptions
            )
            .pipe(catchError(this.handleError));
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    update_user(access: any, id) {
        return this.http
            .post<any>(
                this.serverUrl + 'local/update_user/' + id,
                access,
                this.httpOptions
            )
            .pipe(catchError(this.handleError));
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    update_cash_margin_after_changement(
        coupondetailpost: any
    ) {
        return this.http
            .post<any>(
                this.serverUrl + 'local/update_cash_margin_after_changement',
                coupondetailpost,
                this.httpOptions
            )
            .pipe(catchError(this.handleError));
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    update_pik_margin_after_changement(
        coupondetailpost: any
    ) {
        return this.http
            .post<any>(
                this.serverUrl + 'local/update_pik_margin_after_changement',
                coupondetailpost,
                this.httpOptions
            )
            .pipe(catchError(this.handleError));
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    add_checklist(checklist: any) {
        return this.http
            .post<any>(
                this.serverUrl + 'local/add_checklist',
                checklist,
                this.httpOptions
            )
            .pipe(catchError(this.handleError));
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    add_coupon_detail_cash_pik(
        coupondetailcashpikpost: any
    ) {
        return this.http
            .post<any>(
                this.serverUrl + 'local/add_coupon_detail_cash_pik',
                coupondetailcashpikpost,
                this.httpOptions
            )
            .pipe(catchError(this.handleError));
    } //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })

    add_coupon_detail_pik_interest(
        coupondetailcashpikpost: any
    ) {
        return this.http
            .post<any>(
                this.serverUrl + 'local/add_coupon_detail_pik_interest',
                coupondetailcashpikpost,
                this.httpOptions
            )
            .pipe(catchError(this.handleError));
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    add_coupon_detail_commitment(
        coupondetailcashpikpost: any
    ) {
        return this.http
            .post<any>(
                this.serverUrl + 'local/add_coupon_detail_commitment',
                coupondetailcashpikpost,
                this.httpOptions
            )
            .pipe(catchError(this.handleError));
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    add_coupon_spread_on_ratio(any: any) {
        return this.http
            .post<any>(
                this.serverUrl + 'local/add_coupon_spread_on_ratio',
                any,
                this.httpOptions
            )
            .pipe(catchError(this.handleError));
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    edit_coupon_spread_on_ratio(any: any) {
        return this.http
            .post<any>(
                this.serverUrl +
                'local/update_coupon_spread_on_ratio/' +
                any.id,
                any,
                this.httpOptions
            )
            .pipe(catchError(this.handleError));
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    add_tranche_coupons_detail_margin_history(any: any) {
        return this.http
            .post<any>(
                this.serverUrl + 'local/add_tranche_coupons_detail_margin_history',
                any,
                this.httpOptions
            )
            .pipe(catchError(this.handleError));
    }

    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_coupon_detail_cash_pik(slug) {
        return this.http
            .get<any>(
                this.serverUrl + 'local/get_coupon_detail_cash_pik/' + slug,
                this.httpOptions
            )
            .pipe(catchError(this.handleError));
    }

    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_coupon_detail_cash_ratio(slug) {
        return this.http
            .get<any>(
                this.serverUrl + 'local/get_coupon_detail_cash_ratio/' + slug,
                this.httpOptions
            )
            .pipe(catchError(this.handleError));
    }

    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_coupon_detail_pik_ratio(slug) {
        return this.http
            .get<any>(
                this.serverUrl + 'local/get_coupon_detail_pik_ratio/' + slug,
                this.httpOptions
            )
            .pipe(catchError(this.handleError));
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getcashinterest_next_paymentdate(slug) {
        return this.http
            .get<any>(
                this.serverUrl + 'local/getcashinterest_next_paymentdate/' + slug,
                this.httpOptions
            )
            .pipe(catchError(this.handleError));
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    getpikinterest_next_paymentdate(slug) {
        return this.http
            .get<any>(
                this.serverUrl + 'local/getpikinterest_next_paymentdate/' + slug,
                this.httpOptions
            )
            .pipe(catchError(this.handleError));
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    update_checklist(checklist: any, id) {
        return this.http
            .post<any>(
                this.serverUrl + 'local/update_checklist/' + id,
                checklist,
                this.httpOptions
            )
            .pipe(catchError(this.handleError));
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    delete_checklist(id) {
        return this.http
            .post<any>(
                this.serverUrl + 'local/delete_checklist/' + id,
                this.httpOptions
            )
            .pipe(catchError(this.handleError));
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    delete_company(id, deletionData?: any) {
        const body = deletionData || {};
        return this.http
            .post<any>(
                this.serverUrl + 'company/delete_company/' + id,
                body,
                this.httpOptions
            )
            .pipe(catchError(this.handleError));
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    deleteratio(id) {
        return this.http
            .post<any>(this.serverUrl + 'local/deleteratio/' + id, this.httpOptions)
            .pipe(catchError(this.handleError));
    }

    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_checklist_filtre(colonne, filtre) {
        return this.http
            .get<any>(
                this.serverUrl + 'local/get_checklist_filtre/' + colonne + '/' + filtre,
                this.httpOptions
            )
            .pipe(catchError(this.handleError));
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    get_mkt_contact_filtre(any: any) {
        return this.http
            .post<any>(
                this.serverUrl + 'local/get_mkt_contact_filtre',
                any,
                this.httpOptions
            )
            .pipe(catchError(this.handleError));
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    get_mkt_contact_filtre_by_slug_contact(
        any: any
    ) {
        return this.http
            .post<any>(
                this.serverUrl + 'local/get_mkt_contact_filtre_by_slug_contact',
                any,
                this.httpOptions
            )
            .pipe(catchError(this.handleError));
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    notes_update_put(any: any) {
        return this.http
            .post<any>(
                this.serverUrl + 'local/notes_update_put',
                any,
                this.httpOptions
            )
            .pipe(catchError(this.handleError));
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    notes_create(any: any) {
        return this.http
            .post<any>(
                this.serverUrl + 'local/notes_create',
                any,
                this.httpOptions
            )
            .pipe(catchError(this.handleError));
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    notes_delete_delete(id) {
        return this.http
            .get<any>(
                this.serverUrl + 'local/notes_delete_delete/' + id,
                this.httpOptions
            )
            .pipe(catchError(this.handleError));
    }

    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    notes_read_get($slug) {
        return this.http
            .get<any>(
                this.serverUrl + 'local/notes_read_get/' + $slug,
                this.httpOptions
            )
            .pipe(catchError(this.handleError));
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    // Removed 2026-09-17: update_equipement() — local/update_equipement was deleted (wrote to assets/inventory_afs/, no component called it).

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    update_equipement_without_image(formData, id) {
        return this.http
            .post<any>(
                `${this.serverUrl}local/update_equipement_without_image/` + id,
                formData,
                {
                    reportProgress: true,
                    observe: 'events',
                }
            )
            .pipe(catchError(this.handleError));
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    update_hisotry_equipement(any: any, id) {
        return this.http
            .post<any>(
                this.serverUrl + 'local/update_hisotry_equipement/' + id,
                any,
                this.httpOptions
            )
            .pipe(catchError(this.handleError));
    }

    //Client functions
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_all_client_access() {
        return this.http
            .get<[]>(this.serverUrl + 'local/get_all_client_access')
            .pipe(catchError(this.handleError));
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_client_info_by_slug(slug) {
        return this.http
            .get<
                []
            >(this.serverUrl + 'local/get_client_info_by_slug/' + slug, this.httpOptions)
            .pipe(catchError(this.handleError));
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    add_client_to_deal(filefolderpost: any) {
        return this.http
            .post<any>(
                this.serverUrl + 'local/add_client_to_deal',
                filefolderpost,
                this.httpOptions
            )
            .pipe(catchError(this.handleError));
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    delete_access_client_dataroom(id, slug) {
        return this.http
            .post<any>(
                this.serverUrl +
                'local/delete_access_client_dataroom/' +
                id +
                '/' +
                slug,
                this.httpOptions
            )
            .pipe(catchError(this.handleError));
    }

    /*--------------------------*/

    //Category functions

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    update_category_folder_or_file(filefolderpost: any) {
        return this.http
            .post<any>(
                this.serverUrl + 'local/update_category_folder_or_file/',
                filefolderpost,
                this.httpOptions
            )
            .pipe(catchError(this.handleError));
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    update_category_for_user(filefolderpost: any) {
        return this.http
            .post<any>(
                this.serverUrl + 'local/update_category_for_user/',
                filefolderpost,
                this.httpOptions
            )
            .pipe(catchError(this.handleError));
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    update_category(id_category, slug_deal, categoryaccess: any) {
        return this.http
            .post<any>(
                this.serverUrl +
                'local/update_category/' +
                id_category +
                '/' +
                slug_deal,
                categoryaccess,
                this.httpOptions
            )
            .pipe(catchError(this.handleError));
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    add_category_dataroom(any: any) {
        return this.http
            .post<any>(
                this.serverUrl + 'local/add_category_dataroom',
                any,
                this.httpOptions
            )
            .pipe(catchError(this.handleError));
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_category_dataroom(slug_deal) {
        return this.http
            .get<
                []
            >(this.serverUrl + 'local/get_category_dataroom/' + slug_deal, this.httpOptions)
            .pipe(catchError(this.handleError));
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_category_dataroom_by_parent(slug_deal, id_dossier) {
        return this.http
            .get<
                []
            >(this.serverUrl + 'local/get_category_dataroom_by_parent/' + slug_deal + '/' + id_dossier, this.httpOptions)
            .pipe(catchError(this.handleError));
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    delete_category_folder_or_file(id_category, slug_deal) {
        return this.http
            .get<
                []
            >(this.serverUrl + 'local/delete_category_folder_or_file/' + id_category + '/' + slug_deal, this.httpOptions)
            .pipe(catchError(this.handleError));
    }

    /* CLient access */
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_all_client_access_of_deal(slug) {
        return this.http
            .get<
                []
            >(this.serverUrl + 'local/get_all_client_access_of_deal/' + slug, this.httpOptions)
            .pipe(catchError(this.handleError));
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    add_user_to_external_space(any: any) {
        return this.http
            .post<any>(
                this.serverUrl + 'local/add_user_to_external_space',
                any,
                this.httpOptions
            )
            .pipe(catchError(this.handleError));
    }

    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_client_access_with_sluguser(slug) {
        return this.http
            .get<
                []
            >(this.serverUrl + 'local/get_client_access_with_sluguser/' + slug, this.httpOptions)
            .pipe(catchError(this.handleError));
    }
    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_deal_by_analyst(analyst) {
        return this.http
            .get<
                []
            >(this.serverUrl + 'crm_opportunity/get_deal_by_analyst/' + analyst, this.httpOptions)
            .pipe(catchError(this.handleError));
    }

    //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
    get_deal_by_bu(bu) {
        return this.http
            .get<[]>(this.serverUrl + 'crm_opportunity/get_deal_by_bu/' + bu, this.httpOptions)
            .pipe(catchError(this.handleError));
    }
    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    update_client(any: any, id) {
        return this.http
            .post<any>(
                this.serverUrl + 'local/update_client/' + id,
                any,
                this.httpOptions
            )
            .pipe(catchError(this.handleError));
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    reset_password_client(slug_user) {
        return this.http
            .post<any>(
                this.serverUrl + 'local/reset_password_client/' + slug_user,
                this.httpOptions
            )
            .pipe(catchError(this.handleError));
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    check_principal(slug_tranche: string) {
        const request = { slug_tranche: slug_tranche };
        return this.http
            .post<any>(
                this.serverUrl + 'tranches/check_principal',
                request,
                this.httpOptions
            )
            .pipe(catchError(this.handleError));
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    check_cash_interest(slug_tranche: string) {
        const request = { slug_tranche: slug_tranche };
        return this.http
            .post<any>(
                this.serverUrl + 'tranches/check_cash_interest',
                request,
                this.httpOptions
            )
            .pipe(catchError(this.handleError));
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    check_pik_interest(slug_tranche: string) {
        const request = { slug_tranche: slug_tranche };
        return this.http
            .post<any>(
                this.serverUrl + 'tranches/check_pik_interest',
                request,
                this.httpOptions
            )
            .pipe(catchError(this.handleError));
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    check_coupon(slug_tranche: string) {
        const request = { slug_tranche: slug_tranche };
        return this.http
            .post<any>(
                this.serverUrl + 'tranches/check_coupon',
                request,
                this.httpOptions
            )
            .pipe(catchError(this.handleError));
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    get_crm_reports_conversion_time(request: any) {
        return this.http
            .post<any>(
                this.serverUrl + 'crm_report/get_crm_reports_conversion_time',
                request,
                this.httpOptions
            )
            .pipe(catchError(this.handleError));
    }

    //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
    get_crm_reports_contract_time(request: any) {
        return this.http
            .post<any>(
                this.serverUrl + 'crm_report/get_crm_reports_contract_time',
                request,
                this.httpOptions
            )
            .pipe(catchError(this.handleError));
    }

    exportDataToExcelCalculationFile(identifiant): Observable<Blob> {
        // Ajouter un nouvel objet d'options pour spécifier la réponse attendue comme un blob
        /*     const options = {
                     headers: this.httpOptions.headers,
                     responseType: 'blob' as 'vnd.ms-excel'  // Forcer TypeScript à accepter 'blob' comme type de réponse
                 };
         
                 return this.http.post<Blob>(this.serverUrl + 'local/exportDataToExcelCalculationFile/' + identifiant, options)
                     .pipe(
                         catchError(this.handleError)
                     );*/
        const options = { responseType: 'blob' as 'json' };
        return this.http.get<Blob>(
            this.serverUrl +
            'local/exportDataToExcelCalculationFile' +
            '/' +
            identifiant,
            options
        );
    }

    // ******** Réactivité avec les signals *************

    private isLoadingSignal = signal<boolean>(false);

    getStatus() {
        return this.isLoadingSignal.asReadonly();
    }

    // LES BUs DEV
    private BusdevsSignal = signal<any[]>([]);

    getAllBusdevsSignal() {
        return this.BusdevsSignal.asReadonly();
    }

    get_all_busdev() {
        this.isLoadingSignal.set(true);
        this.http
            .get<[]>(this.serverUrl + 'local/get_users_busdev', this.httpOptions)
            .pipe(catchError(this.handleError))
            .subscribe(busDev => {
                this.BusdevsSignal.set(busDev);
                this.isLoadingSignal.set(false);
            });
    }

    get_busdev() {
        return this.http
            .get<[]>(this.serverUrl + 'local/get_users_busdev', this.httpOptions)
            .pipe(catchError(this.handleError));
    }

    // LES BU
    private buSignal = signal<any[]>([]);

    getAllBuSignal() {
        return this.buSignal.asReadonly();
    }

    get_all_bu() {
        this.isLoadingSignal.set(true);
        this.http
            .get<[]>(this.serverUrl + 'local/get_bu', this.httpOptions)
            .pipe(catchError(this.handleError))
            .subscribe(bu => {
                this.buSignal.set(bu);
                this.isLoadingSignal.set(false);
            });
    }

    // LES STATUTS DES DEALS
    private dealstatusSignal = signal<any[]>([]);

    getAllDealstatusSignal() {
        return this.dealstatusSignal.asReadonly();
    }

    get_all_deal_status() {
        this.isLoadingSignal.set(true);
        this.http
            .get<[]>(this.serverUrl + 'local/get_deal_status', this.httpOptions)
            .pipe(catchError(this.handleError))
            .subscribe(dealStatus => {
                this.dealstatusSignal.set(dealStatus['response']);
                this.isLoadingSignal.set(false);
            });
    }

    get_dashboard_sales(request: any) {
        return this.http
            .post<any>(
                this.serverUrl + 'kpi/get_dashboard_sales',
                request,
                this.httpOptions
            )
            .pipe(catchError(this.handleError));
    }

    // ******** Fin Réactivité avec les signals *************

    /** Logs like handleError() but keeps the response, so callers can read `status`. */
    private rethrowHttpError(error: HttpErrorResponse) {
        console.error(`Backend returned code ${error.status} for ${error.url}`);
        return throwError(() => error);
    }

    private handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(
                `Backend returned code ${error.status}, ` + `body was: ${error.error}`
            );
        }
        // return an observable with a user-facing error message
        return throwError('Something bad happened. Please try again later.');
    }
}
